import React from "react";
import Modal from "../../../Common/Modal";
import Account from "../../../Modals/SelectAccount/partials/account";
import EmptyBeneficiaryIcon from "../../../Icons/EmptyBeneficiaryIcon";

const AccountPopUp = ({
  clientAccounts,
  activeAccount,
  handleChangeAccount,
  accountPopUpOpen,
  setAccountPopUpOpen,
  title,
  children,
}) => {
  const handleOnCloseModal = () => {
    setAccountPopUpOpen(false);
  };

  return (
    <>
      <div onClick={() => setAccountPopUpOpen(true)}>{children}</div>
      <Modal
        isOpen={accountPopUpOpen}
        handleOnCloseModal={handleOnCloseModal}
        header={true}
        headerTitle={title}
        className="w-[432px] max-h-[578px] overflow-scroll hide-scrollbar shadow-xl rounded-3xl"
      >
        <div className="flex flex-col md:px-6 px-3 pb-6 ">
          {clientAccounts.length ? (
            clientAccounts.map((account) => (
              <div
                key={account.id}
                onClick={() => handleChangeAccount(account)}
              >
                <Account {...account} activeAccount={activeAccount} />
              </div>
            ))
          ) : (
            <div className="flex flex-col text-text-primary items-center justify-center py-6">
              <EmptyBeneficiaryIcon className="w-40 h-40" />
              <p>No account found</p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default AccountPopUp;
